
import Vuex from 'vuex'
import Vue from 'vue'
import luckyBalls from './lucky-balls';
import common from './common';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        common,
        luckyBalls
    }
});
